import React from "react";
import { FaSearch, FaUserPlus } from "react-icons/fa";
import {
  isObviousBowlerMatch,
  matchReasonLabel,
} from "../../../utility/bowlerMatch";

export const InlineLookup = ({
  isOpen,
  searchTerm,
  results,
  selectedIndex = -1,
  onSelect,
  isLoading = false,
}) => {
  const obvious = (results || []).some((bowler) =>
    isObviousBowlerMatch(bowler, searchTerm)
  );

  const handleSelect = (bowler) => {
    onSelect(bowler);
  };

  const handleAddNew = () => {
    onSelect({
      id: `new-${Date.now()}`,
      name: searchTerm.trim(),
      usbcID: "",
      average: "",
      email: "",
      phone: "",
      isNew: true,
    });
  };

  if (!isOpen) return null;

  return (
    <div className="relative mt-1">
      <div className="z-10 w-full bg-white border border-brand-charcoal/15 rounded-lg shadow-lg max-h-60 overflow-y-auto">
        {obvious ? (
          <p className="px-4 pt-2 pb-1 text-xs text-brand-charcoal">
            This matches a bowler already on file. Pick that bowler, or create a new one.
          </p>
        ) : results.length > 1 ? (
          <p className="px-4 pt-2 pb-1 text-xs text-brand-charcoal">
            This name matches more than one bowler. Pick one.
          </p>
        ) : null}
        {results.length > 0 ? (
          <div className="py-1">
            {results.map((bowler, index) => {
              const reason = matchReasonLabel(bowler.matchReason);
              return (
                <button
                  type="button"
                  key={bowler.id}
                  onMouseDown={(event) => event.preventDefault()}
                  onClick={() => handleSelect(bowler)}
                  className={`w-full px-4 py-2 text-left hover:bg-brand-cream focus:bg-brand-cream focus:outline-none ${
                    index === selectedIndex
                      ? "bg-brand-cream text-brand-charcoal"
                      : "text-brand-charcoal"
                  }`}
                >
                  <div className="flex items-center space-x-3">
                    <FaUserPlus className="text-brand-mist flex-shrink-0" />
                    <div>
                      <div className="font-medium">{bowler.name}</div>
                      <div className="text-sm text-brand-muted space-y-1">
                        {reason ? <div>{reason}</div> : null}
                        {bowler.usbcID && <div>USBC ID: {bowler.usbcID}</div>}
                        {bowler.average ? (
                          <div>Average: {bowler.average}</div>
                        ) : (
                          <div>No average on file</div>
                        )}
                      </div>
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        ) : (
          <div className="px-4 py-3 text-center text-brand-muted">
            <div className="flex items-center justify-center space-x-2">
              <FaSearch className="text-brand-mist" />
              <span>
                {searchTerm.trim() ? "No matching bowler." : "Start typing to search..."}
              </span>
            </div>
          </div>
        )}
        {searchTerm.trim() && !isLoading ? (
          <div className="border-t border-brand-charcoal/10 px-4 py-2">
            <button
              type="button"
              onMouseDown={(event) => event.preventDefault()}
              onClick={handleAddNew}
              className="w-full flex items-center justify-center space-x-2 text-sm text-brand-gold-ink hover:underline"
            >
              <FaUserPlus />
              <span>Add "{searchTerm}" as new bowler</span>
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};
